import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';

const ICONS = {
  briefcase: <><rect x="2" y="7" width="20" height="13" rx="2" /><path d="M8 7V5a2 2 0 012-2h4a2 2 0 012 2v2M2 12h20" /></>,
  cap: <><path d="M2 9l10-5 10 5-10 5-10-5z" /><path d="M6 11v5c0 1.1 2.7 3 6 3s6-1.9 6-3v-5" /></>,
  target: <><circle cx="12" cy="12" r="9" /><circle cx="12" cy="12" r="5" /><circle cx="12" cy="12" r="1.2" fill="currentColor" /></>,
  cursor: <path d="M4 3l16 8-7 1.5L11 20 4 3z" />,
  check: <path d="M20 6L9 17l-5-5" />,
  shield: <><path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6l8-3z" /><path d="M9 12l2 2 4-4" /></>,
  arrow: <path d="M5 12h14M13 6l6 6-6 6" />,
};

function Icon({ name }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: '100%', height: '100%' }} aria-hidden="true">
      {ICONS[name]}
    </svg>
  );
}

export default function WhyPlanB() {
  const [inView, setInView] = useState(false);
  const [applied, setApplied] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    const prev = document.title;
    document.title = 'Why PlanB Jobs | AI-Powered Job Portal';
    const t = setTimeout(() => setInView(true), 150);
    return () => { clearTimeout(t); document.title = prev; };
  }, []);

  const user = (() => { try { return JSON.parse(localStorage.getItem('user')); } catch { return null; } })();

  /* ---- paste the section content here (same as before) ---- */
  const matches = [
    { role: 'Frontend Developer', meta: 'Bengaluru · Full-time', pct: 94 },
    { role: 'Business Analyst', meta: 'Remote · Full-time', pct: 88 },
    { role: 'Customer Success Executive', meta: 'Pune · Hybrid', pct: 81 },
  ];
  const chips = [
    ['IT', '/jobs/it'], ['Healthcare', '/jobs/healthcare'], ['Finance', '/jobs/banking-finance'],
    ['Sales', '/jobs/sales'], ['Marketing', '/jobs/digital-marketing'], ['Manufacturing', '/jobs/manufacturing'],
    ['Logistics', '/jobs/logistics'], ['Hospitality', '/jobs/hospitality'], ['BPO', '/jobs/bpo'], ['Education', '/jobs/education'],
  ];
  const stages = [
    ['Freshers', 'Start your career', '/jobs?experience=fresher'],
    ['Experienced', 'Make your next move', '/jobs'],
    ['Remote', 'Work from anywhere', '/jobs?work_mode=work_from_home'],
  ];

  return (
    <div className="home-root min-h-screen bg-white overflow-x-clip text-[#1E0F3D]">
      <style>{pageCss}</style>
      <Navbar user={user} />

      <section className={`wp-section ${inView ? 'wp-in' : ''}`}>
        <div className="wp-wrap">
          <div className="wp-head">
            <h2>Job hunting shouldn’t feel like a full-time job.</h2>
            <div>
              <p className="wp-sub">
                PlanB Jobs brings job discovery, employer connections and recruitment tools together in one place, so you spend less time searching.
              </p>
              <Link to="/jobs" className="wp-cta">
                Browse jobs <span style={{ width: 16, height: 16 }}><Icon name="arrow" /></span>
              </Link>
            </div>
          </div>

          <div className="wp-grid">
            <article className="wp-card wp-a">
              <div className="wp-top">
                <div className="wp-icon"><Icon name="target" /></div>
                <div>
                  <h3 className="wp-title">AI-powered job discovery</h3>
                  <p className="wp-body">Explore relevant opportunities based on your skills, experience and preferences.</p>
                </div>
              </div>
              <div className="wp-mock">
                <p className="wp-mock-label">Your skills</p>
                <div className="wp-chips" style={{ marginBottom: 14 }}>
                  {['React', 'Excel', 'Communication', 'SQL'].map((s) => <span key={s} className="wp-chip">{s}</span>)}
                </div>
                <p className="wp-mock-label">Example matches</p>
                {matches.map((m, i) => (
                  <div className="wp-job" key={m.role}>
                    <div><b>{m.role}</b><small>{m.meta}</small></div>
                    <span className="wp-pct">{m.pct}%</span>
                    <div className="wp-bar"><i style={{ '--w': `${m.pct}%`, '--d': `${0.3 + i * 0.2}s` }} /></div>
                  </div>
                ))}
              </div>
            </article>

            <article className="wp-card wp-b">
              <div className="wp-top">
                <div className="wp-icon"><Icon name="shield" /></div>
                <div>
                  <h3 className="wp-title">Verified employers</h3>
                  <p className="wp-body">Discover employers who have completed the platform’s verification process.</p>
                </div>
              </div>
              <div className="wp-mock">
                <div className="wp-co">
                  <span className="wp-logo">A</span>
                  <div><b>Acme Technologies</b><small>Example employer · Bengaluru</small></div>
                  <span className="wp-verified"><span style={{ width: 14, height: 14 }}><Icon name="check" /></span>Verified</span>
                </div>
              </div>
            </article>

            <article className="wp-card wp-c">
              <div className="wp-top">
                <div className="wp-icon"><Icon name="briefcase" /></div>
                <div>
                  <h3 className="wp-title">Opportunities across industries</h3>
                  <p className="wp-body">From IT and healthcare to logistics and hospitality. Tap one to see jobs.</p>
                </div>
              </div>
              <div className="wp-chips">
                {chips.map(([label, to]) => <Link key={label} to={to} className="wp-chip">{label}</Link>)}
              </div>
            </article>

            <article className="wp-card wp-d">
              <div className="wp-top">
                <div className="wp-icon"><Icon name="cursor" /></div>
                <div>
                  <h3 className="wp-title">Simple applications</h3>
                  <p className="wp-body">Create your profile once and apply to relevant jobs without extra forms.</p>
                </div>
              </div>
              <div className="wp-mock wp-apply">
                <button type="button" className={`wp-apply-btn ${applied ? 'done' : ''}`} onClick={() => setApplied((v) => !v)}>
                  {applied ? 'Applied ✓' : 'Apply with profile'}
                </button>
                <small>{applied ? 'Done. That’s all it takes.' : 'Try it: one tap.'}</small>
              </div>
            </article>

            <article className="wp-card wp-e">
              <div className="wp-top">
                <div className="wp-icon"><Icon name="cap" /></div>
                <div>
                  <h3 className="wp-title">Opportunities for everyone</h3>
                  <p className="wp-body">Whether you’re a fresher or an experienced professional, your next opportunity starts here.</p>
                </div>
              </div>
              <div className="wp-stages">
                {stages.map(([name, sub, to]) => (
                  <Link key={name} to={to} className="wp-stage">{name}<small>{sub}</small></Link>
                ))}
              </div>
            </article>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

const pageCss = `
.brand-gradient { background-image: linear-gradient(90deg,#7C3AED,#DB2777); }
.home-root h2 {
  display: inline-block;
  background-image: linear-gradient(90deg,#7C3AED,#DB2777);
  -webkit-background-clip: text; background-clip: text;
  -webkit-text-fill-color: transparent; color: transparent;
}

.wp-section { position: relative; overflow: hidden; background: #fff; color: #1E0F3D; padding: 96px 24px; isolation: isolate; }
.wp-section::before { content: ''; position: absolute; z-index: -1; width: 560px; height: 560px; top: -200px; left: -160px; border-radius: 50%; background: radial-gradient(circle, rgba(124,58,237,.14), transparent 65%); }
.wp-section::after { content: ''; position: absolute; z-index: -1; width: 520px; height: 520px; bottom: -200px; right: -140px; border-radius: 50%; background: radial-gradient(circle, rgba(219,39,119,.12), transparent 65%); }
.wp-wrap { max-width: 1200px; margin: 0 auto; }
.wp-head { display: grid; gap: 24px; grid-template-columns: 1fr; align-items: end; margin-bottom: 48px; }
@media (min-width: 900px) { .wp-head { grid-template-columns: 1.5fr 1fr; gap: 56px; } }
.home-root .wp-section h2 { font-size: clamp(32px, 5vw, 54px); line-height: 1.08; font-weight: 800; letter-spacing: -0.02em; margin: 0; }
.wp-sub { color: #6B7280; font-size: 16px; line-height: 1.65; margin: 0 0 20px; max-width: 420px; }
.wp-cta { display: inline-flex; align-items: center; gap: 8px; color: #fff; font-weight: 700; font-size: 14px; padding: 13px 24px; border-radius: 12px; background: linear-gradient(90deg,#7C3AED,#DB2777); box-shadow: 0 10px 30px -10px rgba(124,58,237,.6); transition: transform .25s cubic-bezier(.2,.8,.2,1), box-shadow .25s; }
.wp-cta:hover { transform: translateY(-2px); box-shadow: 0 16px 34px -10px rgba(219,39,119,.55); }

.wp-grid { display: grid; gap: 16px; grid-template-columns: 1fr; }
@media (min-width: 900px) {
  .wp-grid { grid-template-columns: repeat(6, 1fr); }
  .wp-a { grid-column: 1 / 4; grid-row: 1 / 3; }
  .wp-b { grid-column: 4 / 7; }
  .wp-c { grid-column: 4 / 7; }
  .wp-d { grid-column: 1 / 4; }
  .wp-e { grid-column: 4 / 7; }
}
.wp-card { position: relative; border-radius: 28px; padding: 28px; border: 1px solid #EDE4FB; background: #fff; box-shadow: 0 14px 40px -24px rgba(76,29,149,.35); display: flex; flex-direction: column; gap: 18px; transition: border-color .3s, transform .4s cubic-bezier(.2,.8,.2,1), box-shadow .4s; }
.wp-card:hover { border-color: rgba(219,39,119,.4); transform: translateY(-4px); box-shadow: 0 28px 50px -24px rgba(124,58,237,.45); }
.wp-a { background: linear-gradient(160deg, #F5EEFF, #FFF1F8 80%); }
.wp-icon { width: 46px; height: 46px; padding: 11px; border-radius: 14px; color: #fff; flex-shrink: 0; background: linear-gradient(135deg,#7C3AED,#DB2777); box-shadow: 0 10px 24px -8px rgba(124,58,237,.55); }
.wp-title { font-size: 20px; font-weight: 800; margin: 0 0 6px; letter-spacing: -0.01em; color: #1E0F3D; }
.wp-body { font-size: 14px; line-height: 1.6; color: #6B7280; margin: 0; max-width: 460px; }
.wp-top { display: flex; gap: 16px; align-items: flex-start; }

.wp-mock { border-radius: 18px; background: #fff; border: 1px solid #EDE4FB; padding: 16px; margin-top: auto; box-shadow: 0 8px 24px -18px rgba(76,29,149,.35); }
.wp-mock-label { font-size: 11px; color: #9CA3AF; margin: 0 0 10px; }
.wp-chips { display: flex; flex-wrap: wrap; gap: 6px; }
.wp-chip { font-size: 12px; font-weight: 600; padding: 6px 12px; border-radius: 999px; color: #7C3AED; background: #F5F0FA; border: 1px solid #E9DDFB; transition: background .25s, color .25s, border-color .25s; }
a.wp-chip:hover { background: linear-gradient(90deg,#7C3AED,#DB2777); color: #fff; border-color: transparent; }
.wp-job { display: grid; grid-template-columns: 1fr auto; gap: 4px 12px; padding: 12px 0; border-top: 1px solid #F1E9FB; }
.wp-job:first-of-type { border-top: 0; }
.wp-job b { font-size: 14px; font-weight: 700; color: #1E0F3D; }
.wp-job small { display: block; font-size: 12px; color: #9CA3AF; font-weight: 400; margin-top: 2px; }
.wp-pct { font-weight: 800; font-size: 15px; color: #DB2777; align-self: center; font-variant-numeric: tabular-nums; }
.wp-bar { grid-column: 1 / 3; height: 6px; border-radius: 6px; background: #F1E9FB; overflow: hidden; }
.wp-bar i { display: block; height: 100%; width: 0; border-radius: 6px; background: linear-gradient(90deg,#7C3AED,#DB2777); transition: width 1.3s cubic-bezier(.2,.8,.2,1); transition-delay: var(--d, 0s); }
.wp-in .wp-bar i { width: var(--w); }

.wp-co { display: flex; align-items: center; gap: 12px; }
.wp-logo { width: 42px; height: 42px; border-radius: 12px; background: linear-gradient(135deg,#7C3AED,#DB2777); color: #fff; font-weight: 800; display: flex; align-items: center; justify-content: center; }
.wp-co b { display: block; font-size: 14px; color: #1E0F3D; }
.wp-co small { font-size: 12px; color: #9CA3AF; }
.wp-verified { margin-left: auto; display: inline-flex; align-items: center; gap: 6px; font-size: 12px; font-weight: 700; color: #059669; background: #ECFDF5; border: 1px solid #A7F3D0; padding: 6px 10px; border-radius: 999px; }

.wp-apply { display: flex; align-items: center; gap: 12px; }
.wp-apply-btn { border: 0; cursor: pointer; font-weight: 700; font-size: 14px; padding: 12px 22px; border-radius: 12px; color: #fff; background: linear-gradient(90deg,#7C3AED,#DB2777); transition: transform .2s, background .3s; }
.wp-apply-btn:hover { transform: translateY(-2px); }
.wp-apply-btn.done { background: #10B981; }
.wp-apply small { color: #6B7280; font-size: 12px; }
.wp-apply-btn:focus-visible, .wp-cta:focus-visible, .wp-chip:focus-visible, .wp-stage:focus-visible { outline: 2px solid #7C3AED; outline-offset: 3px; }

.wp-stages { display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px; margin-top: auto; }
.wp-stage { display: flex; flex-direction: column; gap: 4px; padding: 12px; border-radius: 14px; background: #FBF5FF; border: 1px solid #EDE4FB; font-size: 13px; font-weight: 700; color: #1E0F3D; transition: background .25s, border-color .25s, transform .25s, color .25s; }
.wp-stage small { font-weight: 400; font-size: 11px; color: #6B7280; transition: color .25s; }
.wp-stage:hover { background: linear-gradient(135deg,#7C3AED,#DB2777); border-color: transparent; color: #fff; transform: translateY(-2px); }
.wp-stage:hover small { color: rgba(255,255,255,.85); }

@media (prefers-reduced-motion: reduce) {
  .wp-bar i { transition: none; width: var(--w); }
  .wp-card, .wp-cta, .wp-stage, .wp-apply-btn { transition: none; }
}
@media (max-width: 640px) { .wp-section { padding: 64px 16px; } .wp-card { padding: 22px; border-radius: 22px; } }
`;